import { CSSProperties, useMemo } from "react";
import { FlexProps, convertToGap } from "./type";
import { tokens } from "@fluentui/react-components";

export const Flex = (props: FlexProps) => {
	const style = useMemo<CSSProperties>(
		() => ({
			display: "flex",
			gap: tokens[convertToGap(props.gap, props.column)],
			flexDirection: !!props.column ? "column" : "row",
			flexWrap: !!props.wrap ? "wrap" : "nowrap",
			justifyContent: props.hAlign,
			alignItems: props.vAlign,
			...props.style,
		}),
		[props]
	);

	return (
		<div style={style} className={props.className} onClick={props.onClick} id={props.id}>
			{props.children}
		</div>
	);
};
